import React from 'react';
import '../template-file-css/document-file-template.css';


export const RPBS_MasterServicePlanAdult = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='RPBS_MasterServicePlanAdult' className='file-pdf-document'>
            <div className='file-template'>
            <h3>MASTER SERVICE PLAN [Case Management Only] </h3>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>MEDICAID </span></td>
                        <td className='w-375'><span className='eleHeader'>OTHER </span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtMedicaid' name='txtMedicaid' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtOther' name='txtOther' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-250'><span className='eleHeader'>Name: </span></td>
                        <td className='w-250'><span className='eleHeader'>DOB:</span></td>
                        <td className='w-250'><span className='eleHeader'>Age: </span></td>

                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtName' name='txtName' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='date' id='txtDob' name='txtDob' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtAge' name='txtMedicaid' className='add-only' />
                        </td>

                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Gender: </span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>CID#</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Service Plan Date:</span>
                        </td>

                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbActive_Yes' name='rbActive' className='add-only' value='1' /> Male &nbsp;
                            <input type='radio' id='rbActive_No' name='rbActive' className='add-only' value='0' /> Female
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txt_1' name='txt_1' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='date' id='txt_2' name='txt_2' className='add-only' />
                        </td>


                    </tr>

                    <tr>

                        <td className='w-187'>
                            <span className='eleHeader'>Service Plan Date:</span>
                        </td>
                        <td className='w-187'>
                            <span className='eleHeader'>Admitting GAF Score:</span>
                        </td>
                        <td className='w-187'>
                            <span className='eleHeader'>Current GAF Score:</span>
                        </td>
                        <td className='w-187'>
                            <span className='eleHeader'>Current FARS Score:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='date' id='txt_3' name='txt_3' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='text' id='txt_4' name='txt_4' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='text' id='txt_5' name='txt_5' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='text' id='txt_6' name='txt_6' className='add-only' />
                        </td>
                    </tr>

                </table>

                <h4>DSM V (ICD 10) Description or Narrative: </h4>
                <tr>
                    <td className='w-750'>
                        <input type='text' id='txt_7' name='txt_7' className='add-only' /></td>
                </tr>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Axis I:</span>
                            <input type='text' id='txt_8' name='txt_8' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>AXIS I Diagnosis Narrative:</span>
                            <input type='text' id='txt_9' name='txt_9' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Client Long-term View:</span>
                    <textarea id='txt_10' name='txt_10' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Input from Family Members (if applicable):</span>
                    <textarea id='txt_11' name='txt_11' className='add-only'></textarea>
                </p>

                <h4>Goals</h4>


                <p className='w-750'>
                    <h3>1.</h3>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Client Problem/Needs:</span>
                    <textarea id='txt_12' name='txt_12' className='add-only'></textarea>

                    <span className='eleHeader'>Client Goal:</span>
                    <textarea id='txt_13' name='txt_13' className='add-only'></textarea>

                    <span className='eleHeader'>Goal:</span>
                    <textarea id='txt_14' name='txt_14' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <h3>2.</h3>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Client Problem/Needs:</span>
                    <textarea id='txt_15' name='txt_15' className='add-only'></textarea>

                    <span className='eleHeader'>Client Goal:</span>
                    <textarea id='txt_16' name='txt_16' className='add-only'></textarea>

                    <span className='eleHeader'>Goal:</span>
                    <textarea id='txt_17' name='txt_17' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <h3>3.</h3>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Client Problem/Needs:</span>
                    <textarea id='txt_18' name='txt_18' className='add-only'></textarea>

                    <span className='eleHeader'>Client Goal:</span>
                    <textarea id='txt_19' name='txt_19' className='add-only'></textarea>

                    <span className='eleHeader'>Goal:</span>
                    <textarea id='txt_20' name='txt_20' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <h3>4.</h3>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Client Problem/Needs:</span>
                    <textarea id='txt_21' name='txt_21' className='add-only'></textarea>

                    <span className='eleHeader'>Client Goal:</span>
                    <textarea id='txt_22' name='txt_22' className='add-only'></textarea>

                    <span className='eleHeader'>Goal:</span>
                    <textarea id='txt_23' name='txt_23' className='add-only'></textarea>
                </p>



                <h4>Client Objectives</h4>
                <p className='w-750'>
                    <span className='small'>{`(indicate measurable observable changes in target behavior)`}</span></p>


                <p className='w-750'>
                    <h3>1.</h3>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Target Date:</span>
                    <input type='date' id='txt_24' name='txt_24' className='add-only' />

                    <span className='eleHeader'>Goal #</span>
                    <textarea id='txt_25' name='txt_25' className='add-only'></textarea>

                    <span className='eleHeader'>Treatment Provider:</span>
                    <textarea id='txt_26' name='txt_26' className='add-only'></textarea>

                    <span className='eleHeader'>Client Objectives:</span>
                    <textarea id='txt_27' name='txt_27' className='add-only'></textarea>

                    <span className='eleHeader'>CLIENT PROGRESS:</span>
                    <textarea id='txt_27a' name='txt_27a' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <h3>2.</h3>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Target Date:</span>
                    <input type='date' id='txt_28' name='txt_28' className='add-only' />

                    <span className='eleHeader'>Goal #</span>
                    <textarea id='txt_29' name='txt_29' className='add-only'></textarea>

                    <span className='eleHeader'>Treatment Provider:</span>
                    <textarea id='txt_30' name='txt_30' className='add-only'></textarea>

                    <span className='eleHeader'>Client Objectives:</span>
                    <textarea id='txt_31' name='txt_31' className='add-only'></textarea>

                    <span className='eleHeader'>CLIENT PROGRESS:</span>
                    <textarea id='txt_27b' name='txt_27b' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <h3>3.</h3>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Target Date:</span>
                    <input type='date' id='txt_32' name='txt_32' className='add-only' />

                    <span className='eleHeader'>Goal #</span>
                    <textarea id='txt_33' name='txt_33' className='add-only'></textarea>

                    <span className='eleHeader'>Treatment Provider:</span>
                    <textarea id='txt_34' name='txt_34' className='add-only'></textarea>

                    <span className='eleHeader'>Client Objectives:</span>
                    <textarea id='txt_35' name='txt_35' className='add-only'></textarea>

                    <span className='eleHeader'>CLIENT PROGRESS:</span>
                    <textarea id='txt_27c' name='txt_27c' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <h3>4.</h3>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Target Date:</span>
                    <input type='date' id='txt_36' name='txt_36' className='add-only' />

                    <span className='eleHeader'>Goal #</span>
                    <textarea id='txt_37' name='txt_37' className='add-only'></textarea>

                    <span className='eleHeader'>Treatment Provider:</span>
                    <textarea id='txt_38' name='txt_38' className='add-only'></textarea>

                    <span className='eleHeader'>Client Objectives:</span>
                    <textarea id='txt_39' name='txt_39' className='add-only'></textarea>

                    <span className='eleHeader'>CLIENT PROGRESS:</span>
                    <textarea id='txt_27d' name='txt_27d' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <h3>5.</h3>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Target Date:</span>
                    <input type='date' id='txt_40' name='txt_40' className='add-only' />

                    <span className='eleHeader'>Goal #</span>
                    <textarea id='txt_41' name='txt_41' className='add-only'></textarea>

                    <span className='eleHeader'>Treatment Provider:</span>
                    <textarea id='txt_42' name='txt_42' className='add-only'></textarea>

                    <span className='eleHeader'>Client Objectives:</span>
                    <textarea id='txt_43' name='txt_43' className='add-only'></textarea>

                    <span className='eleHeader'>CLIENT PROGRESS:</span>
                    <textarea id='txt_27e' name='txt_27e' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <h3>6.</h3>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Target Date:</span>
                    <input type='date' id='txt_44' name='txt_44' className='add-only' />

                    <span className='eleHeader'>Goal #</span>
                    <textarea id='txt_45' name='txt_45' className='add-only'></textarea>

                    <span className='eleHeader'>Treatment Provider:</span>
                    <textarea id='txt_46' name='txt_46' className='add-only'></textarea>

                    <span className='eleHeader'>Client Objectives:</span>
                    <textarea id='txt_47' name='txt_47' className='add-only'></textarea>

                    <span className='eleHeader'>CLIENT PROGRESS:</span>
                    <textarea id='txt_27f' name='txt_27f' className='add-only'></textarea>
                </p>

                <h3>CLIENT TERMINATION CRITERIA</h3>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Objective #</span>
                            <input type='text' id='txt_48' name='txt_48' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Date Terminated:</span>
                            <input type='date' id='txt_49' name='txt_49' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Termination Criteria:</span>
                    <textarea id='txt_50' name='txt_50' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Objective #</span>
                            <input type='text' id='txt_51' name='txt_51' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Date Terminated:</span>
                            <input type='date' id='txt_52' name='txt_52' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Termination Criteria:</span>
                    <textarea id='txt_53' name='txt_53' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Objective #</span>
                            <input type='text' id='txt_54' name='txt_54' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Date Terminated:</span>
                            <input type='date' id='txt_55' name='txt_55' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Termination Criteria:</span>
                    <textarea id='txt_56' name='txt_56' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Objective #</span>
                            <input type='text' id='txt_57' name='txt_57' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Date Terminated:</span>
                            <input type='date' id='txt_58' name='txt_58' className='add-only' />
                        </td>

                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Termination Criteria:</span>
                    <textarea id='txt_59' name='txt_59' className='add-only'></textarea>
                </p>

                <h3>Methods</h3>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>For problem numbers:</span>
                            <input type='text' id='txt_60' name='txt_60' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Dated:</span>
                            <input type='date' id='txt_61' name='txt_61' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-187'>
                            <span className='eleHeader'>Service Types</span>
                        </td>
                        <td className='w-187'>
                            <span className='eleHeader'>Frequency</span>
                        </td>
                        <td className='w-187'>
                            <span className='eleHeader'>Length of Session</span>
                        </td>
                        <td className='w-187'>
                            <span className='eleHeader'>Duration of Treatment</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cb_92' name='cb_92' className='add-only' value='1' /> Assessment/Review
                        </td>
                        <td className='w-187'>
                            <input type='text' id='txt_93' name='txt_93' className='add-only w-100 custom-add-only' /> X Annually
                        </td>
                        <td className='w-187'>
                            <input type='text' id='txt_94' name='txt_94' className='add-only w-50 custom-add-only' /> Hours
                            <input type='text' id='txt_95' name='txt_95' className='add-only w-50 custom-add-only' /> Min

                        </td>
                        <td className='w-187'>
                            <input type='text' id='txt_96' name='txt_96' className='add-only'/>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cb_97' name='cb_97' className='add-only' value='1'/> Medication Management/Monitoring
                        </td>
                        <td className='w-187'>
                            <input type='text' id='txt_98' name='txt_98' className='add-only w-80 custom-add-only'/>X
                            <input type='text' id='txt_99' name='txt_99' className='add-only w-80 custom-add-only'/>
                        </td>
                        <td className='w-187'>
                            <input type='text' id='txt_100' name='txt_100' className='add-only w-50 custom-add-only'/> Hours
                            <input type='text' id='txt_101' name='txt_101' className='add-only w-50 custom-add-only'/> Min

                        </td>
                        <td className='w-187'>
                            <input type='text' id='txt_102' name='txt_102' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cb_103' name='cb_103' className='add-only' value='1' /> Psychiatric Evaluation/Update
                        </td>
                        <td className='w-187'>
                            <input type='text' id='txt_104' name='txt_104' className='add-only w-100 custom-add-only' /> X Annually
                        </td>
                        <td className='w-187'>
                            <input type='text' id='txt_105' name='txt_105' className='add-only w-50 custom-add-only'/> Hours
                            <input type='text' id='txt_106' name='txt_106' className='add-only w-50 custom-add-only'/> Min

                        </td>
                        <td className='w-187'>
                            <input type='text' id='txt_106' name='txt_106' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cb_107' name='cb_107' className='add-only' value='1' /> Case Management/Monitoring
                        </td>
                        <td className='w-187'>
                            <input type='text' id='txt_108' name='txt_108' className='add-only w-80 custom-add-only'/> X
                            <input type='text' id='txt_109' name='txt_109' className='add-only w-80 custom-add-only'/>

                        </td>
                        <td className='w-187'>
                            <input type='text' id='txt_109' name='txt_109' className='add-only w-50 custom-add-only'/> Hours
                            <input type='text' id='txt_110' name='txt_110' className='add-only w-50 custom-add-only'/> Min

                        </td>
                        <td className='w-187'>
                            <input type='text' id='txt_111' name='txt_111' className='add-only'/> 
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cb_112' name='cb_112' className='add-only' value='1'/> Other

                        </td>
                        <td className='w-187'>
                            <input type='text' id='txt_113' name='txt_113' className='add-only w-80 custom-add-only'/> X
                            <input type='text' id='txt_114' name='txt_114' className='add-only w-80 custom-add-only'/>

                        </td>
                        <td className='w-187'>
                            <input type='text' id='txt_115' name='txt_115' className='add-only w-50 custom-add-only'/> Hours
                            <input type='text' id='txt_116' name='txt_116' className='add-only w-50 custom-add-only'/> Min

                        </td>
                        <td className='w-187'>
                            <input type='text' id='txt_117' name='txt_117' className='add-only'/>
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Referral Agencies:</span>
                            <input type='text' id='txt_119' name='txt_119' className='add-only'/>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Agency Phone Number:</span>
                            <input type='text' id='txt_120' name='txt_120' className='add-only'/>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Agency Phone Number:</span>
                            <input type='text' id='txt_121' name='txt_121' className='add-only'/>
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>I/We/have participated in the development of this plan.</span>
                            <input type='radio' id='rb_122_1' name='rb_122' className='add-only' value='1'/> Yes &nbsp;
                            <input type='radio' id='rb_122_2' name='rb_122' className='add-only' value='2'/> No<br /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Client Initials</span>
                            <input type='text' id='txt_123' name='txt_123' className='add-only'/>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>I/We/have recieved a copy of this plan.</span>
                            <input type='radio' id='rb_124_1' name='rb_124' className='add-only' value='1'/> Yes &nbsp;
                            <input type='radio' id='rb_124_2' name='rb_124' className='add-only' value='2'/> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Client Initials</span>
                            <input type='text' id='txt_125' name='txt_125' className='add-only'/>
                        </td>
                    </tr>
                </table>


                
            </div>
        </form>

    )
}











